import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BHExpHooks extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'BHExpHooks'
  // Define default properties here
  static instanceDefaults() {
    return {};
  }
}
const servicePath = '/bh-exp-hooks';
const servicePlugin = makeServicePlugin({
  Model: BHExpHooks,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin